import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {IStep} from '../../shared/model/step.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<IStep>;
type EntityArrayResponseType = HttpResponse<IStep[]>;

@Injectable({ providedIn: 'root' })
export class StepService {
    public resourceUrl = SERVER_API_URL + 'api/steps';

    constructor(protected http: HttpClient) {}

    create(step: IStep): Observable<EntityResponseType> {
        return this.http.post<IStep>(this.resourceUrl, step, { observe: 'response' });
    }

    update(step: IStep): Observable<EntityResponseType> {
        return this.http.put<IStep>(this.resourceUrl, step, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IStep>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IStep[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    getRunPartList(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IStep[]>(this.resourceUrl+'-run-part', { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
